import type { IToggle } from 'unleash-proxy-client';

import { Home, IssueReporter } from '@/component';
import { SHORTCUT_CONST } from '@/constant';
import { useApiErrorHandler } from '@/hook';
import { ShortcutProvider, UnleashProvider } from '@/package';
import {
  ApiProvider,
  AuthProvider,
  CollectionProvider,
  DelegationProvider,
  RoleProvider,
  VersionCheckerProvider,
  VueronSprintProvider,
  WebSocketProvider,
} from '@/provider';
import featureList from '@/repository/unleash/featureList.json';

const HomePage = () => {
  useApiErrorHandler();

  return (
    <DelegationProvider>
      <ApiProvider>
        <VersionCheckerProvider>
          <AuthProvider>
            <WebSocketProvider>
              <UnleashProvider
                config={{
                  appName: 'sapporo',
                  clientKey: import.meta.env.VITE_APP_UNLEASH_CLIENT_KEY,
                  context: {
                    sessionId: '',
                  },
                  refreshInterval: 60,
                  url: `${import.meta.env.VITE_APP_UNLEASH_URL}/api/frontend`,
                }}
                fallbackToggleList={featureList as IToggle[]}
              >
                <VueronSprintProvider>
                  <RoleProvider>
                    <CollectionProvider>
                      <ShortcutProvider
                        defaultShortcut={SHORTCUT_CONST.DEFAULT_SHORTCUT_MAP}
                        shortcutCommand={SHORTCUT_CONST.SHORTCUT_COMMAND}
                        shortcutNamespace={SHORTCUT_CONST.SHORTCUT_NAMESPACE}
                      >
                        <Home />
                        <IssueReporter />
                      </ShortcutProvider>
                    </CollectionProvider>
                  </RoleProvider>
                </VueronSprintProvider>
              </UnleashProvider>
            </WebSocketProvider>
          </AuthProvider>
        </VersionCheckerProvider>
      </ApiProvider>
    </DelegationProvider>
  );
};

export default HomePage;
